import { Moon, Sun } from "lucide-react";
import { useTema } from "@/lib/tema";
import { cn } from "@/lib/cn";
import { cevir } from "@/lib/dil";

export function ThemeToggle({ className }: { className?: string }) {
  const { dark, setTema } = useTema();
  return (
    <button
      type="button"
      aria-label={dark ? cevir("Switch to light theme") : cevir("Switch to dark theme")}
      onClick={() => setTema(dark ? "light" : "dark")}
      className={cn(
        "inline-flex h-9 w-9 items-center justify-center rounded-md border border-line bg-surface text-ink-2 transition-colors hover:border-line-strong hover:text-ink",
        className,
      )}
    >
      {dark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
